export const SCRIPT_ID = 'tiny-mce-core-source'
export const THROTTLE_DURATION = 300
export const TINY_MCE_SOURCE = 'https://s3.amazonaws.com/procore-core/tinymce'
export const TINY_MCE_VERSION = '4.7.13'

export const DEFAULT_PLUGINS = [
  'autolink',
  'autoresize',
  'lists',
  'nonbreaking',
  'paste',
  'textcolor',
]

export const PLUGINS = [
  'advlist',
  'anchor',
  'autolink',
  'autoresize',
  'autosave',
  'bbcode',
  'charmap',
  'code',
  'codesample',
  'colorpicker',
  'contextmenu',
  'directionality',
  'emoticons',
  'fullpage',
  'fullscreen',
  'help',
  'hr',
  'image',
  'imagetools',
  'importcss',
  'insertdatetime',
  'legacyoutput',
  'link',
  'lists',
  'media',
  'nonbreaking',
  'noneditable',
  'pagebreak',
  'paste',
  'preview',
  'print',
  'save',
  'searchreplace',
  'spellchecker',
  'tabfocus',
  'table',
  'template',
  'textcolor',
  'textpattern',
  'toc',
  'visualblocks',
  'visualchars',
  'wordcount',
]

export const TINY_MCE_CONFIG = {
  autoresize_overflow_padding: 12,
  autoresize_bottom_margin: 0,
  browser_spellcheck: true,
  convert_url: false,
  content_css: `${TINY_MCE_SOURCE}/${TINY_MCE_VERSION}/tinymce.min.css`,
  extended_valid_elements:
    'table[class=mce-table|border:1px double #000|cellpadding: 3px|style=border-collapse: collapse; border-color: #000]',
  min_height: 96,
  invalid_elements: 'form,script',
  menubar: false,
  nonbreaking_force_tab: true,
  paste_preprocess: (_: any, args: any) => {
    args.content = args.content.replace(/<pre>/gi, '<p>')
    args.content = args.content.replace(/<\/pre>/gi, '</p>')
  },
  paste_remove_styles_if_webkit: true,
  paste_retain_style_properties: 'font-size,text-decoration',
  paste_word_valid_elements:
    '@[style],pre,-strong/b,-em/i,-span,-p,-ol,-ul,-li,-table,-tr,-td[colspan|rowspan],-th,-thead,-tfoot,-tbody,-a[href|name],sub,sup,strike,br,u',
  statusbar: false,
  skin_url: `${TINY_MCE_SOURCE}/${TINY_MCE_VERSION}/skins/lightgray`,
  toolbar:
    'bold italic underline alignleft aligncenter alignright bullist numlist outdent indent cut paste pastetext fontsizeselect forecolor backcolor undo redo',
}

function generatePluginUrl(plugin: string) {
  return `${TINY_MCE_SOURCE}/${TINY_MCE_VERSION}/plugins/${plugin}/plugin.min.js`
}

export function generateExternalPlugins(plugins: Array<string>) {
  return Array.from(new Set(plugins.concat(DEFAULT_PLUGINS))).reduce(
    (acc, plugin) => {
      return PLUGINS.includes(plugin)
        ? Object.assign(acc, { [plugin]: generatePluginUrl(plugin) })
        : acc
    },
    {}
  )
}
